import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";

const ProtectedRoute = ({ children, sellerOnly = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const accountType = useSelector((state) => state.local.accountType);
  const token =
    useSelector((state) => state.local.token) ||
    localStorage.getItem("falconTokenUser");
  const { t } = useTranslation();

  if (!token) {
    Swal.fire({
      title: t("Login Required"),
      text: t("Please sign in to access this page"),
      icon: "info",
      showCancelButton: true,
      confirmButtonText: t("OK"),
      cancelButtonText: t("Cancel"),
      allowOutsideClick: false,
      allowEscapeKey: false,
    }).then((result) => {
      if (result.isConfirmed) {
        navigate("/login", { state: { from: location }, replace: true });
      }
    });
    return null;
  }

  // if (!token) {
  //   Swal.fire({
  //     title: t("Login Required"),
  //     text: t("Please sign in to access this page"),
  //     icon: "info",
  //     showCancelButton: true,
  //     confirmButtonText: t("OK"),
  //     cancelButtonText: t("Cancel"),
  //     allowOutsideClick: false,
  //     allowEscapeKey: false,
  //   }).then(() =>
  //     navigate("/login", { state: { from: location }, replace: true })
  //   );
  //   return null;
  // }

  if (sellerOnly && accountType !== "Seller") {
    Swal.fire({
      title: t("Seller Account Needed"),
      html: `<p>${t(
        "This section requires seller privileges. Switch account type?"
      )}</p>`,
      icon: "info",
      showCancelButton: true,
      confirmButtonText: t("Switch to Seller"),
      cancelButtonText: t("Back to Buyer"),
    }).then((result) => {
      result.isConfirmed
        ? navigate("/seller-home", { replace: true })
        : navigate("/", { replace: true });
    });
    return null;
  }

  return children;
};

export default ProtectedRoute;
